import React, { useEffect, useRef } from 'react'

function Skills() {
    const skillpic = useRef(null)
    useEffect (()=>{
        const handleScroll = () =>{
            const value = window.scrollY
            skillpic.current.style.transform = `translateX(-${value / 1.5 }px)`
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
  return (
    <div id='Skills' ref={skillpic} className='flex mt-20 *:mr-40'>
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download.png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (1).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (2).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (3).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (4).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (5).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/download (6).png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/icon7-rnNk6UlU.png" alt="" />
        <img className='w-20 h-20 md:w-32 md:h-32' src="/Image/icon4-4uk4K4Zg.png" alt="" />
    </div>
  )
}

export default Skills